import reportService from "./reportService"
export function errorHandler(message){
    let messagedata={}
    messagedata.name=message.message
    messagedata.type='test'//测试环境
  //  messagedata.type='produce'//正式环境
    if(message){
        // reportService.prototype.Errorreport({
        //     Category:1, // 分类, 1-js错误 !!required!!
        //     Content:JSON.stringify(messagedata), // 错误内容 !!required!!
        //     Instance: '公众号' // 所属项目 !!required!!
        // }).then(res=>{
    
        // }).catch(err=>{
            
        // })
    }  
}


// WEBPACK FOOTER //
// ./src/service/errorHandler.js